import apiFetch from 'api/base'
import { AxiosPromise } from 'axios'

const URL = `/geo/info`

const loadGeoInfo = (): AxiosPromise => apiFetch(URL)

export default loadGeoInfo
